export default __webpack_public_path__ + "static/media/logo.2335d050.png";